import { render } from "./productPageHeader.vue?vue&type=template&id=0540e1e8&scoped=true&ts=true"
import script from "./productPageHeader.vue?vue&type=script&lang=ts"
export * from "./productPageHeader.vue?vue&type=script&lang=ts"

import "./productPageHeader.vue?vue&type=style&index=0&id=0540e1e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0540e1e8"]])

export default __exports__